<template>
    <v-main>
        <div style="height:100vh;">
            <v-row style="height:100vh;">
                <v-col cols="12" sm="12" md="6" lg="6"
                    class="d-flex justify-center align-lg-center align-md-center align-xl-center">
                    <img src="@/assets/images/img-sorteo/sininscribete.png" class="img-izquierda">
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6"
                    class="d-flex justify-center align-sm-start align-lg-center align-md-center align-xl-center">
                    <v-row no-gutters>
                        <v-col cols="12" class="text-center pt-2">
                            <img src="@/assets/images/img-sorteo/inscribete.png" class="img-inscribete">
                        </v-col>
                        <v-col cols="12" class="d-flex justify-center align-lg-center align-md-center align-xl-center">
                            <div>

                                <div class="mx-3">

                                    <v-card class="pa-3 mt-4 card mb-8" elevation="0" outlined width="500"
                                        max-height="1200">


                                        <div class="text-center ">
                                            <v-overlay :value="overlay" absolute :opacity="0.03">
                                                <v-progress-circular indeterminate size="64"
                                                    :color="theme"></v-progress-circular>
                                            </v-overlay>
                                        </div>
                                        <div class="mb-2"> <label class="px-2">Ingresa tus datos</label></div>
                                        <div class="mb-3">
                                            <v-btn-toggle color="deep-purple darken-1" v-model="typeIdentificacion"
                                                @change="toggleIdentificacion()" mandatory dense>
                                                <v-btn value="CED">
                                                    <b>CED</b>
                                                </v-btn>
                                                <v-btn value="RUC">
                                                    <b>RUC</b>
                                                </v-btn>
                                                <v-btn value="PAS">
                                                    <b>PAS</b>
                                                </v-btn>
                                            </v-btn-toggle>
                                        </div>
                                        <v-form ref="form" v-model="valid" lazy-validation validate>
                                            <div class="mb-4">
                                                <v-row no-gutters>
                                                    <v-col cols="12" class="px-1">
                                                        <v-text-field width="10%" type="text" :color="theme" flat dense
                                                            outlined v-model="identificacion" :rules="identificacionRules"
                                                            label="Identificación" required></v-text-field>
                                                    </v-col>

                                                </v-row>
                                                <v-row no-gutters>
                                                    <v-col cols="6" class="px-1">
                                                        <v-text-field :color="theme" flat dense outlined v-model="name"
                                                            :rules="nameRules" label="Nombre"></v-text-field>

                                                    </v-col>
                                                    <v-col cols="6" class="px-1">
                                                        <v-text-field :color="theme" flat dense outlined v-model="apellido"
                                                            :rules="apellidoRules" label="Apellido" required></v-text-field>
                                                    </v-col>
                                                </v-row>

                                                <v-row no-gutters>
                                                    <v-col cols="6" class="px-1">
                                                        <v-text-field :color="theme" flat dense outlined v-model="userInsta"
                                                            :rules="userInstaRules"
                                                            label="Usuario de Instagram"></v-text-field>

                                                    </v-col>
                                                    <v-col cols="6" class="px-1">
                                                        <v-text-field :color="theme" flat dense outlined v-model="ciudad"
                                                            :rules="ciudadRules" label="Ciudad" required></v-text-field>
                                                    </v-col>
                                                </v-row>

                                                <v-row no-gutters>
                                                    <v-col cols="6" class="px-1"><v-text-field :color="theme" flat dense
                                                            outlined v-model="email" :rules="emailRules" label="Correo"
                                                            required></v-text-field></v-col>
                                                    <v-col cols="6" class="px-1">
                                                        <v-text-field :color="theme" type="number" flat dense outlined
                                                            v-model="celular" :counter="10" :rules="celularRules"
                                                            label="Celular" required></v-text-field>
                                                    </v-col>
                                                </v-row>
                                                <v-row no-gutters>
                                                    <v-col cols="12" class="pb-3 ps-3">
                                                        <span
                                                            class="deep-purple--text text--accent-4 font-weight-bold">Adjunta
                                                            la
                                                            captura
                                                            de
                                                            tu post de
                                                            Instagram</span>
                                                    </v-col>
                                                    <v-col class="px-1" cols="12" lg="6" md="6" sm="12" xl="6">
                                                        <input type="file" @change="cargarImagen" accept="image/*" />
                                                    </v-col>
                                                    <v-col class="px-1 text-center" cols="12" lg="6" md="6" sm="12" xl="6"
                                                        v-if="imagen">
                                                        <img v-if="imagen" :src="imagenURL"
                                                            alt="Previsualización de la imagen"
                                                            style="max-width: 90px; max-height : 100px;" />
                                                    </v-col>

                                                </v-row>
                                            </div>
                                            <div class="">
                                                <v-switch :color="theme" :rules="switchRules" class="mt-0" v-model="switch1"
                                                    inset required>
                                                    <template v-slot:label>
                                                        <div>
                                                            <template>
                                                                <span>Acepto los términos, condiciones y
                                                                    <a target="_blank"
                                                                        href="http://www.promociones.superexito.com.ec/terminoscondiciones"
                                                                        @click.stop style="text-decoration: none;">
                                                                        políticas de privacidad
                                                                    </a></span>

                                                            </template>

                                                        </div>

                                                    </template>
                                                </v-switch>
                                                <span class="ps-15 grey--text text--darken-1">Lee las bases y condiciones
                                                    <a target="_blank"
                                                        href="http://www.promociones.superexito.com.ec/basesyCondiciones"
                                                        @click.stop style="text-decoration: none;">
                                                        aquí.
                                                    </a>
                                                </span>
                                            </div>
                                            <div class="text-center mt-5">
                                                <v-btn :color="theme" class="mt-3 white--text camel-case-btn"
                                                    @click="guardar('I')" large :disabled="!imagenURL">
                                                    inscribirme
                                                </v-btn>
                                            </div>
                                        </v-form>

                                    </v-card>
                                </div>
                                <!-- modal dialog -->
                                <div class="text-center">
                                    <v-dialog v-model="showModal" width="600">
                                        <v-card class="fondo-modal fondo-modal">
                                            <div class="pa-4" style="position: absolute; right:0">
                                                <v-btn icon @click="showModal = false">
                                                    <v-icon color="white">mdi-close</v-icon></v-btn>
                                            </div>
                                            <img v-if="nameImg == 0" src="@/assets/images/img-sorteo/participando.png"
                                                width="100%">

                                            <img v-if="nameImg == 1" src="@/assets/images/img-sorteo/actualizacion.png"
                                                width="100%">
                                            <v-card-actions v-if="nameImg == 1" class="d-flex justify-center">
                                                <div class="text-center">
                                                    <v-btn class="mx-2 purple--text" color="white" @click="guardar('U')">
                                                        Actualizar
                                                    </v-btn>
                                                </div>
                                            </v-card-actions>
                                            <img v-if="nameImg == 2" src="@/assets/images/img-sorteo/intentos.png"
                                                width="100%">

                                            <img v-if="nameImg == 4" src="@/assets/images/img-sorteo/cierre.png"
                                                width="100%">
                                        </v-card>
                                    </v-dialog>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
    </v-main>
</template>
<script>
import promocionesService from '@/services/promocionesService';
import { ipServer } from '@/services/rutaService';


export default {
    components: {
    },
    data: () => ({
        mensajeModal: '',
        disableIndentidicacion: false,
        overlay: false,
        nameImg: null,
        text_btn: 'hols',
        pdfUrl: '/politicas.pdf',
        theme: 'deep-purple accent-4',
        dominioServer: ipServer,
        switch1: false,
        switchRules: [v => !!v || 'Debe aceptar los terminos y condiciones'],
        valid: true,
        name: '',
        nameRules: [
            v => !!v || 'Nombre es obligatorio',

        ],

        userInsta: '',
        userInstaRules: [
            v => !!v || 'Campo es obligatorio',

        ],

        ciudad: '',
        ciudadRules: [
            v => !!v || 'Campo es obligatorio',

        ],

        apellido: '',
        apellidoRules: [
            v => !!v || 'Apellido es obligatorio',
        ],
        identificacion: '',
        identificacionRules: [
            v => !!v || 'Identicación es obligatorio',
            v => validarCedula(v) || 'Identicación no valida',
        ],
        celular: '',
        celularRules: [
            v => !!v || 'Celular es obligatorio',
            v => /^\d+$/.test(v) || 'Ingrese solo números',
            v => /^\d{1,10}$/.test(v) || 'Cantidad de digitos incorrecto'

        ],
        email: '',
        emailRules: [
            v => !!v || 'Correo es obligatorio',
            v => /.+@.+\..+/.test(v) || 'Correo no valido',
        ],
        checkbox: false,
        typeIdentificacion: '',
        showModal: false,
        showModal2: false,
        info: [],
        imagen: null,
        imagenURL: null,

    }),

    methods: {
        async openHandler(pdfApp) {
            this.info = [];
            const info = await pdfApp.pdfDocument
                .getMetadata()
                .catch(console.error.bind(console));

            if (!info) return;
            const props = Object.keys(info.info);
            props.forEach((prop) => {
                const obj = {
                    name: prop,
                    value: info.info[prop]
                };
                this.info.push(obj);
            });
        },
        async guardar(tipo) {
            try {
                this.showModal = false;
                if (this.$refs.form.validate()) {
                    const formData = new FormData();
                    formData.append('file', this.imagen);
                    formData.append('identificacion', this.identificacion);
                    formData.append('nombre', this.name);
                    formData.append('apellido', this.apellido);
                    formData.append('telefono', this.celular);
                    formData.append('correo', this.email);
                    formData.append('userInstagram', this.userInsta);
                    formData.append('ciudad', this.ciudad);
                    formData.append('tipo', tipo);
                    this.overlay = true;
                    let response = await promocionesService.registraClienteSorteo(formData);
                    this.overlay = false;
                    let resp = response.data
                    if (resp.codigo == 0) {
                        this.showModal = true;
                        this.nameImg = 0;
                        this.limpiar();
                    }
                    else if (resp.codigo == 1) {
                        this.nameImg = 1;
                        this.showModal = true;

                    } else if (resp.codigo == 2) {
                        this.nameImg = 2;
                        this.showModal = true;
                        this.mensajeModal = resp.mensaje
                        //alert(resp.mensaje);
                    }
                    else if (resp.codigo == 4) {
                        this.nameImg = 4;
                        this.showModal = true;
                    }
                    else {
                        this.overlay = false;
                        alert(resp.mensaje);
                    }
                }
            } catch (error) {
                this.overlay = false;
                alert(error);
                console.log(error)
            }
        },
        limpiar() {
            this.$refs.form.resetValidation()
            this.$refs.form.reset()
            this.imagen = null;
            this.imagenURL = null

        },
        validaForm() {
            if (this.celular.length != 10) {
                return false
            }
        },
        toggleIdentificacion() {
            tipoIde = this.typeIdentificacion;
            validarCedula(this.identificacion)
        },
        openDialog(title, type, message, show, size, theme, accion) {
            this.showModal = true;
            this.modalValues = {
                title: title,
                type: type,
                message: message,
                show: show,
                size: size,
                theme: theme,
                accion: accion,
            }
        },
        closeDialog() {
            this.showModal = false
        },
        cargarImagen(event) {
            const archivo = event.target.files[0];
            if (archivo && archivo.type.startsWith('image/')) {
                const lector = new FileReader();
                lector.onload = (e) => {
                    this.imagen = archivo;

                    this.imagenURL = e.target.result;
                };
                lector.readAsDataURL(archivo);
            } else {
                // Reiniciar la previsualización si no se seleccionó una imagen válida
                this.imagen = null;
                this.imagenURL = null;
            }
        },

    }, beforeMount() {
        // this.showModal = true;
        // this.ambienteProduccion(false);



    }
}



let tipoIde = 'CED';
function validarCedula(identificacion) {
    if (identificacion) {
        if (tipoIde == 'CED') {
            let cad = identificacion.trim();
            let total = 0;
            let longitud = cad.length;
            let longcheck = longitud - 1;
            if (cad !== "" && longitud === 10) {
                for (let i = 0; i < longcheck; i++) {
                    if (i % 2 === 0) {
                        let aux = cad.charAt(i) * 2;
                        if (aux > 9) aux -= 9;
                        total += aux;
                    } else {
                        total += parseInt(cad.charAt(i));
                    }
                }
                total = total % 10 ? 10 - total % 10 : 0;
                if (cad.charAt(longitud - 1) == total) {
                    return true;
                } else {
                    return false;
                }
            }
        } if (tipoIde == 'RUC') {
            if (identificacion.length !== 13) {
                return false;
            }

            /* 
               var provincia = parseInt(identificacion.substr(0, 2), 10);
               if (provincia < 1 || provincia > 24) {
                   return false;
               }
    */


            return true;
        } if (tipoIde == 'PAS') {
            if (identificacion.length > 15) {
                return false;
            }


            /*   var regex = /^[a-zA-Z0-9]+$/;
               if (!regex.test(identificacion)) {
                   return false;
               }
    */
            return true;
        }
    }



}
</script>
<style scoped>
@import '@/assets/styles/styles-descuento-datos/style-datos.css';

.fondo-modal {
    background: url('/src/assets/images/img-sorteo/fondo.png') no-repeat center center fixed;
    background-size: cover;

}

input[type=file]::file-selector-button {
    margin-right: 2px;
    border: none;
    background: #6200ea;
    padding: 5px 10px;
    border-radius: 5px;
    color: #fff;
    cursor: pointer;
    transition: background .2s ease-in-out;
}

input[type=file]::file-selector-button:hover {
    background: #6200ea;
}

.camel-case-btn {
    text-transform: none;
    white-space: nowrap;
}

.camel-case-btn::first-letter {
    text-transform: uppercase;
}
</style>